export default "__VITE_ASSET__gZxIIA_d__"